/* eslint global-require: 0 */
import axios from 'axios';
import { apiUrl, useSSO } from 'config';
import { get, set } from 'lodash';
import moment from 'moment';

const TOKEN_EXPIRES_PATH_LOCAL_STORAGE = 'expires';
const TOKEN_PATH_LOCAL_STORAGE = 'token';
const REFRESH_TOKEN_PATH_LOCAL_STORAGE = 'refreshToken';

const expandWM = (data) => {
  if (!data) {
    return data;
  } else if (data.Message) {
    return { Message: data.Message };
  } else if (data) {
    return { ...data.Entity, ...data };
  }
  return data;
};
const expandWMList = (list) => {
  if (!list) {
    return [];
  } else if (list.Message) {
    return { Message: list.Message };
  } else if (list) {
    return list.map(expandWM);
  }
  return list;
};
const customTransformResponse = func => [].concat(
  axios.defaults.transformResponse,
  func,
);


/* Create custom instance of axios with baseURL from config */
export const custom = axios.create({
  baseURL: apiUrl,
});

export const core = axios.create({
  baseURL: apiUrl,
});

export const injectQDataInterceptor = (interceptor) => {
  if (interceptor) {
    custom.interceptors.request.use(interceptor);
  }
};

export const refresh = refreshToken => core({
  url: '/Token',
  method: 'POST',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  data: `grant_type=refresh_token&refresh_token=${refreshToken}`,
});


if (!useSSO) {
  custom.interceptors.request.use(async (config) => {
    set(config, 'headers.Content-Type', 'application/json');
    set(config, 'headers.Accept', 'application/json');
    const accessTokenExpires = parseInt(localStorage.getItem(TOKEN_EXPIRES_PATH_LOCAL_STORAGE), 10);
    const accessToken = localStorage.getItem(TOKEN_PATH_LOCAL_STORAGE);
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_PATH_LOCAL_STORAGE);

    try {
      // Access token is expired and we need to fetch a new one
      if (!accessTokenExpires
        || !moment(accessTokenExpires).isValid()
        || moment(accessTokenExpires).isBefore(moment().add(5, 'm'))
      ) {
        const refreshResponse = await refresh(refreshToken);
        const newAccessToken = get(refreshResponse, ['data', 'access_token'], '');
        const newAccessTokenExpires = Date.now() + get(refreshResponse, ['data', 'expires_in'], 0);
        const newRefreshToken = get(refreshResponse, ['data', 'refresh_token'], '');
        localStorage.setItem(TOKEN_EXPIRES_PATH_LOCAL_STORAGE, newAccessTokenExpires);
        localStorage.setItem(TOKEN_PATH_LOCAL_STORAGE, newAccessToken);
        localStorage.setItem(REFRESH_TOKEN_PATH_LOCAL_STORAGE, newRefreshToken);

        const authorization = newAccessToken ? `Bearer ${newAccessToken}` : undefined;
        set(config, 'headers.Authorization', authorization);
      } else {
        const authorization = accessToken ? `Bearer ${accessToken}` : undefined;
        set(config, 'headers.Authorization', authorization);
      }
    } catch (e) {
      window.location.replace('/account?logout=true');
    }

    return config;
  });
}


export const base = ({
  entity, action, ...args
}) =>
  custom({
    url: `/api/QDataEntity/${action}/${entity}`,
    method: 'POST',
    ...args,
  });

export const read = ({ entityID, ...args }) =>
  base({
    action: 'Read',
    data: JSON.stringify(entityID),
    ...args,
  });

export const list = ({ ...args }) =>
  base({
    action: 'List',
    ...args,
  });

export const create = ({ ...args }) =>
  base({
    action: 'Create',
    ...args,
  });

export const save = ({ ...args }) =>
  base({
    action: 'Save',
    ...args,
  });

export const remove = ({ ...args }) =>
  base({
    action: 'Delete',
    ...args,
  });

export const readWM = ({ entity, entityID, ...args }) =>
  custom({
    url: `/api/QDataWebModel/${entity}/${entityID}`,
    transformResponse: customTransformResponse(expandWM),
    ...args,
  });

export const listWM = ({ entity, ...args }) =>
  custom({
    url: `/api/QDataWebModel/${entity}`,
    transformResponse: customTransformResponse(expandWMList),
    ...args,
  });



// WEBPACK FOOTER //
// ./src/utils/Api.js